import React from 'react'
import classnames from 'classnames'

const conditionalLink = (onClick, children) => {
  return onClick ?
    <a onClick={onClick}>{children}</a> :
    children
}

/**
 * 
 * Provides a  wrapper around svg elements
 */
const Shell = ({ className, onClick, title, children }) => (
  conditionalLink(onClick,
    <svg
      className={classnames({
        'icon': true,
        [className]: className,
        'icon__clickable': onClick
      })}
      width="100"
      height="100"
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      {children}
    </svg>
  )
)

const DashIcon = ({className, onClick}) => (
  <Shell className={className} onClick={onClick} title="Dash">
    <path stroke="currentColor" vectorEffect="non-scaling-stroke" fill="none" d="M 10 65 L 80 65" />
  </Shell>
)

export default DashIcon


// WEBPACK FOOTER //
// ./src/password-policy/dash-icon.jsx